// extracted by mini-css-extract-plugin
module.exports = {"contactInfo":"DepartmentContactInfo_contactInfo__-bQg1"};